import type { OrderResponseReturnLabel } from 'shared/services/api/models'
import { type OrderCarrierNowData } from 'shared/services/api/models/orders/OrderCarrierNowData'

export const PLACEHOLDER_URL =
  'https://static.shop-apotheke.com/media/content/placeholder.png'

/**
 * Interfaces for Order / Orderdraft objects
 */
export interface Order {
  customerMasterData: CustomerMasterData
  orderMasterData: OrderMasterData
  subOrders?: SubOrders[]
}
export interface CustomerMasterData {
  customerNumber: string
  dateOfBirth: string
  email: string
  firstName: string
  isEavCustomer: boolean
  lastName: string
  phoneNumber: string
  salutation: string
}
export interface OrderMasterData {
  currency: string
  language: string
  orderDate: string
  orderNumber: string
  prescriptionFollows: boolean
  totalAmount: number
  totalAmountDiscountRedpoints: number
  totalAmountDiscountVoucher: number
  totalAmountDiscounts: number
  totalAmountDocuments: number
  totalAmountPrescriptionBonus: number
  totalAmountPrescriptionBonusDiscount: number
  totalAmountPrescriptionBonusToAccount: number
  totalAmountRedeemedRedpoints: number
  totalAmountRedpoints: number
  totalAmountShippingCost: number
}
export interface SubOrders {
  discounts?: unknown
  subOrderId: string
  sellerId: string
  sellerName: string
  orderType: string
  status: string
  billingAddress: BillingAddress
  carrier: Carrier
  deliveryAddress: DeliveryAddress
  orderDocuments: OrderDocuments[]
  orderDocumentsERx?: OrderDocuments[]
  payment: Payment
  shippedDate: string
  totalAmount: number
  totalAmountDocuments: number
  totalAmountPrescriptionBonus: number
  totalAmountRedpoints: number
  documentsToDownload?: unknown
  returnable: boolean
  returnLabel: OrderResponseReturnLabel
  returnCarriers: string[]
  cancellable: boolean
  cancellationStatus: string
  cancellations?: Cancellation[]
  subAmountWithLineDiscounts?: number
}

export interface Cancellation {
  cancelId: string
  source: string
  items: CancellationItem[]
}

export interface CancellationItem {
  pzn: string
  cartInsertOrder: number
  quantity: number
}

export interface BillingAddress {
  city: string
  countryCode: string
  doorCode: string
  extension: string
  id: string
  street: string
  streetNo: string
  letterBox: string
  type: string
  zip: string
  valid: boolean
  streetCode: string
}
export interface Carrier {
  identifier: string
  costs: number
  displayName: string
  trackingId: string
  externalCarrierIds: ExternalCarrierIds
  nowData?: OrderCarrierNowData
}
export interface ExternalCarrierIds {
  parcellab: string
}
export interface DeliveryAddress {
  city: string
  countryCode: string
  extension: string
  firstName: string
  id: string
  lastName: string
  salutation: string
  street: string
  streetNo: string
  letterBox: string
  type: string
  zip: string
}
export interface OrderDocuments {
  documentPositions: DocumentPositions[]
  type: string
}
export interface DocumentPositions {
  amountRedpoints: number
  entryType: string
  availability: string
  canonicalURL: string
  cartInsertOrder: number
  isCoolingRequired: boolean
  itemName: string
  itemTax: number
  lineAmount: number
  lineDiscountPercent: number
  lineNum: number
  packagingQuantity: string
  packagingUnit: string
  pharmaForm: string
  prescriptionBonus: number
  pricePerUnit: PricePerUnit
  pzn: string
  quantity: number
  salesPrice: number
  thumbnailURL: string
  upid: string
  subtitle?: string
  isCancellable: boolean
  isClaimable: boolean
}
export interface PricePerUnit {
  formatted: string
}
export interface Payment {
  paymentKind: string
  paymentProviderTransactionId: string
  paymentStatus: string
}

export interface PaymentInformation {
  paymentInformation: {
    bankAccountHolder: string
    bankName: string
    bic: string
    iban: string
    paymentReference: string
  }
}
